import React from "react";
import coupleImg from "../../Assets/review/db2.jpg";
import heading from "../../Assets/SignUp/heading.png";
import bg from "../../Assets/SignUp/bg.png";
import absolute from "../../Assets/SignUp/absolute.png";
import { FaArrowLeftLong } from "react-icons/fa6";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { forgotPassword } from "../../Redux/Actions/AuthAction";
import { CircularProgress } from "@mui/material";
import useTitle from "../../Hooks/useTitle";

const Checkemail = () => {
    useTitle('Check mail')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, userData } = useSelector((state) => state.Auth);
    const email = userData.email;

    const handleResendOtp = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Email field is required")
            return navigate('/forgot-password')
        }
        try {
            const res = await dispatch(forgotPassword(email))
            if (!res) {
                return toast.error('something went wrong!!')
            } else {
                toast.success(res.data.message);
                navigate('/check-your-email');
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    const openMail = (e) => {
        e.preventDefault();
        const domain = email.split('@')[1];
        let url = 'https://mail.google.com'; // default fallback

        if (domain.includes('gmail')) {
            url = 'https://mail.google.com';
        } else if (domain.includes('yahoo')) {
            url = 'https://mail.yahoo.com';
        } else if (domain.includes('outlook') || domain.includes('hotmail') || domain.includes('live')) {
            url = 'https://outlook.live.com';
        } else if (domain.includes('icloud')) {
            url = 'https://www.icloud.com/mail';
        }

        window.open(url, '_blank');
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 h-screen overflow-hidden">
            {/* Left Side Image */}
            <div className="hidden md:flex relative justify-center items-center p-4 h-full overflow-hidden">
                <div className="w-full h-full relative">
                    <img
                        src={coupleImg}
                        alt="Couple"
                        className="w-full h-full object-cover rounded-xl"
                    />
                    {/* Overlay Content */}
                    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
                        <img src={absolute} alt="Decorative Icon" className="mx-auto mb-2" />
                        <h1 className="text-2xl lg:text-3xl font-bold">Add USA</h1>
                        <h2 className="text-xl lg:text-2xl font-bold">Gujarati Community</h2>
                    </div>
                </div>
            </div>

            {/* Right Side Form */}
            <div
                className="flex items-center justify-center h-full w-full p-6 md:p-10"
                style={{
                    backgroundImage: `url(${bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="w-full max-w-md md:max-w-lg lg:max-w-xl bg-white p-6 md:p-8 rounded-xl">
                    <div className="flex justify-center">
                        <img src={heading} alt="Matrimony" className="h-10 md:h-12 w-28 md:w-32" />
                    </div>
                    <h2 className="text-center text-lg md:text-xl font-semibold mt-2">Check Your Email</h2>
                    <h3 className="text-center text-md text-gray-500 mt-2">We sent a password reset link to</h3>
                    <h3 className="text-center text-sm mt-1 font-medium">{userData?.email || "user"}</h3>
                    <form className="flex flex-col">
                        <button onClick={openMail} className="w-full bg-[#E72848] text-white p-3 my-4 rounded-xl font-semibold hover:bg-[#f53b58] transition duration-300 cursor-pointer">
                            Open Email App
                        </button>

                        <p className="text-center text-sm flex justify-center">
                            Don’t receive the email?
                            <button
                                onClick={handleResendOtp}
                                className="text-red-500 font-semibold ml-1 hover:underline flex justify-center"
                            >
                                {
                                    loading ? <CircularProgress size={24} color="inherit" /> : " Click to Resend"
                                }

                            </button>
                        </p>

                        <div className="text-center flex justify-center mt-6 gap-2 text-gray-600 cursor-pointer hover:text-gray-800 transition duration-300">
                            <FaArrowLeftLong size={20} />
                            <NavLink to="/signin" className="text-md text-[#535861] font-medium">Back to Log in</NavLink>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Checkemail;
